import React from 'react';

import Popup from '../../Popup';
import styles from './welcomePopUps.scss';

class InboxWelcomePopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {
            onCloseClick,
            onCtaClick,
        } = this.props;

        return (
            <Popup
                className={`popup-md`}
                popUpClassName={`${styles.welcomePopUp}`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,
                    scrollable: false,
                }}
                data-testid="modal.inbox-welcome"
            >
                <div className={`${styles.section} pt0`}>
                    <h4 data-testid="modal.inbox-welcome.heading">Welcome to UTR Sports Messaging!</h4>
                </div>
                <div className={`${styles.section} pt0`}>
                    <p data-testid="modal.inbox-welcome.description">Connect with organizers and players to better coordinate your activity.</p>
                    <p className="text-error" data-testid="modal.inbox-welcome.warning">Warning: UTR Sports reserves the right to disable your messaging and/or suspend your account if you spam or send inappropriate content to other users.</p>

                    <div className="bb" />
                    <button
                        className="btn btn-primary btn-xl btn-block text-uppercase"
                        onClick={onCtaClick}
                        type="button"
                        data-testid="modal.inbox-welcome.cta-btn"
                    >
                        Got It
                    </button>
                </div>
            </Popup>
        );
    }
}

export default InboxWelcomePopUp;
